import camelcaseKeys from "camelcase-keys";
import { useQuery } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";

import config from "../config";
import { AXIOS } from "./axios";
import { useAuth } from "../components/auth/AuthProvider";
import { MetaSchema, PaginationSchema } from "./pagination";

export type Event = {
  id: string;
  url: string;
  tos: { hash: string; version: string };
  type: string;
  email: string;
  status: "success" | "failed";
  key: { id: string; name: string };
  project: { id: string; name: string };
  message: string;
  updatedAt: string;
};

type Custom = {
  type?: string;
  email?: string;
  status?: string;
  project?: string;
};

export const useEvents = (body: PaginationSchema & Custom) => {
  const role = useAuth().user.activeOrganization.role;
  const PROXY = useAuth().user.activeOrganization.url;

  const url = role === "sys.admin" ? config.url.CONFG : PROXY;

  return useQuery<
    AxiosResponse<any, any>,
    AxiosError<{ error: string; message: string }>,
    { data: Event[]; meta: MetaSchema }
  >({
    queryKey: [`EVENTS ${JSON.stringify(body)}`],
    queryFn: () => AXIOS.post(`${url}/events`, body),
    select: (data) => camelcaseKeys(data.data, { deep: true }),
    retry: 2,
  });
};
